import React from "react";
import { useNavigate } from "react-router-dom";

const events = [
  {
    title: "Events And Shows",
    description: "Discover a range of new activities, shows, and diverse performances spread throughout the...",
    image: "f1.png", // Замените на реальный путь к изображению
  },
  {
    title: "Daily Events",
    description: "The festival features a variety of daily events and interactive entertainment shows, providing you with...",
    image: "f2.png",
  },
  {
    title: "Festivals List",
    description: "Each week features a variety of activities and special events, ensuring a new experience with...",
    image: "f3.png",
  },
  {
    title: "Layali Alwathba",
    description: "This year, the Sheikh Zayed Festival will have many concerts by different artists. Enjoy a mix of...",
    image: "f4.png",
  },
];

const FestivalActivities = () => {
  
    const navigate = useNavigate()
  
    return (
    <div className="px-5 py-10 flex flex-col items-center text-white bg-[#768397]">
      <h2 className="mb-6 text-3xl font-semibold text-center">FESTIVAL ACTIVITIES</h2>
      <div className="flex px-4 space-x-4 w-full overflow-x-scroll md:overflow-x-auto md:justify-center">
        {events.map((event, index) => (
          <div className="rounded-lg  flex-shrink-0 overflow-hidden">
            
          <div
            key={index}
            className="flex-none overflow-hidden p-2 text-[#122553] bg-white  shadow-lg w-72"
            >
            <img
              src={event.image}
              alt={event.title}
              className="object-cover rounded-lg w-full h-48"
              />
            <div className="p-4">
              <h3 className="mb-2 text-lg font-bold">{event.title}</h3>
              <p className="text-sm">{event.description}</p>
            </div>
              </div>
            <div className="w-full py-2 bg-[#FBAD36]"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FestivalActivities;
